/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Api_Errors_Empty_FileInputs */

const nl_import_api_errors_empty_file = /** @type {(inputs: Import_Api_Errors_Empty_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het bestand is leeg`)
};

/**

* @param {Import_Api_Errors_Empty_FileInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const import_api_errors_empty_file = /** @type {((inputs?: Import_Api_Errors_Empty_FileInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Api_Errors_Empty_FileInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_import_api_errors_empty_file(inputs)
});
export { import_api_errors_empty_file as "import.api_errors.empty_file" }